<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Sebep</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name"></v-validator>
            <input type="text" v-model="value.Name" class="form-control" placeholder="Sebep"/>
        </div>
        <div class="col-12 mt-1" v-if="value.ParentJobExitSpecialCauseId == null">
            <label class="form-label">SGK Parametreleri</label>
            <v-select-list v-model="sgkParameters" multiple label="Value" placeholder="SGK Parametreleri" :options="parameters"/>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            parameters:[]
        }
    },
    mounted(){
        if(this.value.ParentJobExitSpecialCauseId == null){
            this.getParameters()
        }
    },
    methods:{
        getParameters(){
            EmployeeOperationsApi.Employee.SGK.Type("istenCikisNedeni").then(res=>{
                this.parameters = res.data.Data?.map(r=>({
                    ...r,
                    Value:[r.Code,r.Value].join(" - ")
                })).sort((a,b) => Number(a.Code) - Number(b.Code))
            })
        },
    },  
    computed:{
        sgkParameters:{
            get:function(){
                return this.parameters.filter(b=>this.value.SGKParameterIds.includes(b.ParameterId))
            },
            set:function(value){
                this.value.SGKParameterIds = value?.map(v=>v.ParameterId) || []
            }
        }
    }
}
</script>

<style>

</style>